import { render } from "./CustomerDetailsView.vue?vue&type=template&id=b01fcbd8&scoped=true&ts=true"
import script from "./CustomerDetailsView.vue?vue&type=script&lang=ts"
export * from "./CustomerDetailsView.vue?vue&type=script&lang=ts"

import "./CustomerDetailsView.vue?vue&type=style&index=0&id=b01fcbd8&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b01fcbd8"]])

export default __exports__